import { render, staticRenderFns } from "./cardBody.vue?vue&type=template&id=6e829592&"
import script from "./cardBody.vue?vue&type=script&lang=js&"
export * from "./cardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports